import { createServiceClient } from "shared/welda/services/axiosClient";

const apiTracker = createServiceClient("/tracker");

const getMailDetails = async (params) =>
  await apiTracker.post("/getMailDetails", params);

const trackingService = {
  getMailDetails,
};

export default trackingService;
